export default {
  computed: {
    noteCategoryOptions() {
      return [{
        label: this.$t("application-form.general"),
        value: "general"
      }, {
        label: this.$t("application-form.admin"),
        value: "admin"
      }, {
        label: this.$t("application-form.follow-up"),
        value: "follow-up"
      }, {
        label: this.$t("application-form.urgent"),
        value: "urgent"
      }, {
        label: this.$t("application-form.system"),
        value: "system"
      }, {
        label: this.$t("application-form.conversion"),
        value: "conversion"
      }];
    }
  }
};